



















































import Vue, { PropOptions } from 'vue';

export default Vue.extend({
  name: 'TopBar',
  props: {
    itemsPerPage: Number,
    total: Number,
  },
  data() {
    return {
      viewPages: 1,
    };
  },
  computed: {
    visiblePageRange(): any[] {
      const range = [];
      const maxVisible = 5;
      let start = Math.max(1, this.viewPages - 2);
      const end = Math.min(this.totalPages, start + maxVisible - 1);
      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }
      for (let i = start; i <= end; i++) {
        range.push(i);
      }
      return range;
    },
    totalPages(): number {
      return Math.ceil(this.total / this.itemsPerPage) || 1;
    },
  },
  watch: {
    total: {
      async handler(newValue, oldInput) {
        this.changePage(1);
      },
    },
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.viewPages = page;
        this.$emit('changePage', this.viewPages);
        // window.scrollTo({ top: 100, behavior: 'smooth' });
      }
    },
  },
});
